module.exports = __webpack_public_path__ + "./fonts/Asap-Medium.ttf";